import {createAction, createAsyncThunk} from '@reduxjs/toolkit';

import request from '@apps-common/js-client/api/request';

export const reset = createAction('SELECTED_SCENE_RESET');

export const load = createAsyncThunk(
  'SELECTED_SCENE_LOAD',
  (_, {dispatch, getState, rejectWithValue}) => {
    const {provenanceData} = getState();

    if (!provenanceData) {
      dispatch(reset());
      return;
    }

    return request
      .get(provenanceData)
      .then(res => res.data)
      .catch(err => rejectWithValue(err));
  }
);
